<template>
	<MobileShell v-if="$isMobile">
		<slot />
	</MobileShell>
	<DesktopShell v-else>
		<slot />
	</DesktopShell>
</template>

<script setup>
import DesktopShell from "~/components/layout-shell/DesktopShell.vue";
import MobileShell from "~/components/layout-shell/MobileShell.vue";

const { $isMobile } = useNuxtApp();
</script>
